import { render, staticRenderFns } from "./NutritionRiskBadge.vue?vue&type=template&id=7a636faf&scoped=true&"
import script from "./NutritionRiskBadge.vue?vue&type=script&lang=js&"
export * from "./NutritionRiskBadge.vue?vue&type=script&lang=js&"
import style0 from "./NutritionRiskBadge.vue?vue&type=style&index=0&id=7a636faf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a636faf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
